import "../tool.js";
import "../../singleton/form_builder/index.js";
import "../modals/form_editor.js";
import "../helpers.js";

class FormEditorTool {
  constructor() {
    this.name = "form-editor";
    this.templateId = "form-editor";
    this.filterFields = "submission";

    this.bind = function (component) {
      jQuery(this.element).on("click.form-editor-tool", "button", initFormBuilder.bind(this));

      function initFormBuilder() {
        var formData = Sparkle.PageBuilder.Helpers.deepCopy(component.context) || {};
        formData.fields = formData.fields || []; // Set an empty fields array if we don't already have one

        var formBuilder = new FormBuilder(window.FORM_TEMPLATES, formData, { filterFields: this.filterFields });

        var modal = new Sparkle.PageBuilder.Modal.FormEditor({
          body: formBuilder.el,
          onComplete: function () {
            updateFormComponent(formBuilder.formData);
          },
        });
        modal.show();
      }

      function updateFormComponent(formData) {
        component.save(formData);
        component.render();
      }
    };

    this.unbind = function (element) {
      jQuery(this.element).off(".form-editor-tool");
    };
  }
}

window.FormEditorTool = FormEditorTool;
